var App = App || {};

App.LoginModalHandler = (function ($) {
    "use strict";

    function init() {
        var $customLoginModal = $("#CustomLoginModal");
        if ($customLoginModal.length) {
            var hashValue = window.location.hash.substring(1);
            if (!isNullOrEmpty(hashValue) && hashValue.toLowerCase() == "customloginmodal") {
                $customLoginModal.modal('show');
            }

            $("a, button").click(function (e) {
                var $triggerButton = $(this);
                if (!isNullOrEmpty($triggerButton.attr("href")) && ($triggerButton.attr("href").toLowerCase() == "#customloginmodal" || $triggerButton.attr("href").toLowerCase() == "/customloginmodal")) {
                    e.preventDefault();
                    $customLoginModal.modal('show');

                    $customLoginModal.one('hidden.bs.modal', function () {
                        $triggerButton.focus();
                    })
                }
            });
        }
    }

    function isNullOrEmpty(string) {
        return (!string || string.trim().length === 0)
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.LoginModalHandler.init();
});